<template>
    <el-form v-if="model" ref="form" :model="model" :rules="rules" label-width="120px">
        <el-form-item v-for="field in fields" :key="field.name" :prop="field.name" :label="field.title">
            <news-field-input v-model="model[field.name]" :field="field"></news-field-input>
        </el-form-item>
    </el-form>
</template>

<script>
    import NewsFieldInput from './NewsFieldInput'
    export default {
        name: "NewsForm",
        components: {NewsFieldInput},
        props: {
            data: Object,
            datasource: Object,
        },
        data(){
            return {
                model: null,
                rules: null,
                fields: null
            }
        },
        created(){
            this.init()
        },
        watch:{
            data(){
                this.init()
            },
            datasource(){
                this.init()
            }
        },
        methods: {
            init(){
                const model = {}
                const rules = {}
                const fields = []
                for(const field of this.datasource.fields){
                    if(field.type === 'HIGHLIGHT'||['deleted','editor','editTime'].indexOf(field.name)!==-1){
                        continue
                    }
                    model[field.name] = this.data.source?this.data.source[field.name]:null
                    fields.push(field)
                    const fieldRules = []
                    if(!field.nullable){
                        fieldRules.push({required: true, message: '请输入'+field.title, trigger: 'blur'})
                    }
                    if(field.type === 'LONG'||field.type === 'LONG'||field.type === 'LONG'){
                        fieldRules.push({type: 'integer', message: '请输入整数', trigger: 'blur'})
                    }
                    if(fieldRules.length>0){
                        rules[field.name] = fieldRules
                    }
                }
                this.rules = rules
                this.fields = fields
                this.model = JSON.parse(JSON.stringify(model))
                if(this.$refs.form){
                    this.$refs.form.clearValidate()
                }
            },
            validate(){
                return this.$refs.form.validate()
            },
            getModel(){
                return this.model
            }
        }
    }
</script>

<style scoped>

</style>
